import { useContext } from 'react'
import { GlobalLoadingContext } from 'core/contexts'

const useInitialLoading = (isLoading?: boolean, isUpdating?: boolean): boolean => {
  const isGlobalLoading = useContext(GlobalLoadingContext)
  return (isLoading !== false || !!isUpdating) && !isGlobalLoading
}

export default useInitialLoading
